const translations = {
    header: {
        title: 'Tecnocampus Enrollment Access Form',
        sub_title: 'If this is the first year that you study in our center, we would appreciate it if you would dedicate a few minutes of your time to fill out this survey.',
        description: 'It will help us to plan the reception of your classmates in subsequent courses and, in general, to improve the quality of our services..'
    },
    btns_form:{
        next: 'Next',
        previous: 'Previous',
        submit: 'Submit'
    },
    title: 'New student survey form',
    sub_title: 'Fill in the following form',
    survey_close: {
        msg: 'Closed survey!',
        sub_msg: 'We regret to inform you that the survey, New access to Tecnocampus Degrees, is closed'
    },
    tabs:{
        personal_data: {
            title: 'Personal data',
            name: 'Name',
            surname1: 'Surname',
            surname2: 'Second surname',
            dni: 'NIF/NIE/Passport',
            phone: 'Mobile phone',
            gender: 'Gender',
            email: 'Mail',
            birthday: 'Birth date',
            grade: 'Degree you are studying',
            provincia: 'Province',
            population: 'Municipality of residence',
            country: 'Country',
            placeholder_country: 'Select a country',
            question1: 'If during the academic year you do not live in your municipality of residence, indicate what type of accommodation you live in (tick one of the options)',
            question2_1 :'Will you combine studies with a job?',
            question2_2: 'If yes, indicate one of the following options'
        },
        photo:{
            title: 'Photography',
            intro: 'This photograph will be used to generate your student card.',
            requirements_title: 'The photograph must meet the following criteria, otherwise it will not allow you to continue, and it will not be possible to generate the high-vostra correctly:',
            requirements: [
                "The size of the photograph cannot exceed <strong>max 4Mb</strong> of weight",
                "The image must have a minimum size of 176px wide and 220px high.",
                "The photo must be of the bust type. It means that the image can NOT be full body, or half body, at most from the chest up, or only face, it is <strong>It is very important that the whole face is seen and that it is identifiable</strong>, preferably with a white background."
            ],
            instructions: 'Drag an image in the box or use the \'Add photo\' button',
            add_photo: 'Add photo',
            crop_photo: 'Crop image',
            remove_photo: 'Remove photo',
            note: 'This photo is the one that will be used for your student card and for the virtual campus',
            upload_photo: 'Upload photo',
            make_photo: 'Take photo',
            file_title: 'ID Photo',
            select_webcam: 'Select the camera',
            take_snapshot: 'Take snapshot',
            errors: {
                no_foto: "<p>You have not added any photos</p>",
                mida: "<p>Remember: </p>" +
                    "<p>Measures 175px wide and 220px maximum height</p>" +
                    "<p>The weight of the file must not be more than 4Mb</p>",
                mida_superada: 'The file size exceeds 4Mb or does not meet the minimum required sizes.'
            }
        },
        academic_data: {
            title: 'Academic data',
            description: 'Academic data of the last studies completed',
            question1: 'Studies completed (indicate only the last studies you have done)',
            question2: 'Type of high school completed',
            question3: 'Academic Center (of the latest studies)',
        },
        title_selection:{
            title: 'Selection Degree/Center',
            description: 'Selection of the Degree and the Center',
            question1: 'Rate from 0 (least important) to 10 (very important) the different aspects that have helped you decide to choose to study at the Tecnocampus',
            question2: 'How have you not known?',
            errors: {
                missing_answers: 'There are unanswered answers'
            }
        },
        expectations:{
            title: 'Expectations',
            description: 'Expectations',
            question1: 'Rate from 1 (not very important) to 5 (very important) the following aspects according to the importance you think they should have in order to receive a good university education',
            errors: {
                missing_answers: 'There are unanswered answers'
            }
        },
        comunication: {
            title: 'Communication',
            description: 'Communication',
            question1:'Indicates communication channels; through which you would like to receive information about your studies and/or the news of the university',
            errors: {
                missing_answers: 'There are unanswered answers'
            }
        },
        transport:{
            title: 'Transport',
            description: 'Transport',
            question1: 'Mark the means of transport you will use to come to study at the center. If some days you come with one medium and others with a different one, mark only the one that will be most common.',
            errors: {
                missing_answers: 'There are unanswered answers'
            }
        },
        impressions: {
            title: 'Impressions',
            description: 'First impressions',
            question1: 'Evaluate the quality of the information available on the registration process (documentation that you have to deliver, when you have to come, day and time, place, etc.).',
            question2: 'Assesses the quality of the academic information (information; of the studies to be taken: teaching plans, timetables, etc.) available before enrollment',
            question3: 'Other comments you want to make, addressed to the Center Management',
            policies_accepted: 'I accept the conditions of the <a target="_blank" href="http://www.tecnocampus.cat/ca/avis-legal">Privacy Policy</a>',
            policies: '<b>I expressly authorize the Fundación Tecnocampus Mataró-Maresme to process my personal data in order to carry out the statistical treatment of the surveys of new access students..</b>\n' +
                ' The personal data provided will be incorporated into the data file <b>“Student survey for new access”</b>.\n' +
                ' Statistical data is not used with associated names. These data will only be transferred to third parties in those cases in which it is necessary for the fulfillment of the legally established obligations..\n' +
                ' We inform you that at any time you can exercise your rights of access, rectification, deletion and opposition, by sending a document identified with the reference "Data Protection", which is accompanied by a photocopy\n' +
                ' of the national identity document of the owner of the data, and in which the petition in which the request is specified, an address for the purposes of notifications, date and signature, at the following electronic address\n' +
                ' rgpd@tecnocampus.cat, or by means of a prepaid letter addressed to the General Secretariat of the Fundación Tecnocampus Mataró-Maresme (Avenida de Ernest Lluch, 32 Edificio Universitario, 08302 Mataró).',
            errors: {
                missing_answers: 'There are unanswered answers'
            }
        },
        end:{
            title: 'End',
            thanks: 'Thank you for taking the survey, here is your record',
            detail1: 'An email has been sent to your email address with confirmation of survey registration,\n' +
                '        <strong>it is necessary to bring the receipt with the documentation on the day of enrollment</strong>',
            detail2: 'If you wish, you can print the data in the following table as a receipt or if you prefer, you can print the receipt that has been sent to you by mail',
            guard: 'Receipt of the enrollment survey form for new access to Tecnocampus',
            guard_title:'Data of the registration made',
            print:'Print receipt'
        }
    }
}

export default  translations;